import React, {useState, useEffect, useRef} from "react";
import {Container, Card, Form} from "react-bootstrap";
// import "./Security.css";
import "./ReportSection.css";
import axios from "../../util/Axios/AxiosInstance";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import filterFactory, {textFilter} from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import ToolkitProvider, {
    CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {addDays, addMonths, addYears, format} from "date-fns";
import Skeleton from "react-loading-skeleton";
import {DateRangePicker} from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarDays} from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";

function SecurityReportPage() {
    const [tableData, setTableData] = useState([
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
        {
            transactionDate: <Skeleton/>,
            vendorName: <Skeleton/>,
            labourName: <Skeleton/>,
            entryType: <Skeleton/>,
            shiftName: <Skeleton/>,
            createdDate: <Skeleton/>,
            createdBy: <Skeleton/>
        },
    ]);
    let [formatDate, setFormatDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rangeValue, setRangeValue] = useState(10);
    const [limitRange, setLimitRange] = useState(0);
    const [branchCode, setBranchCode] = useState(
        localStorage.getItem("branchId")
    );
    const [range, setRange] = useState([
        {
            startDate: addMonths(new Date(), -1),
            endDate: new Date(),
            key: "selection",
        },
    ]);
    const [open, setOpen] = useState(false);
    const refSelect = useRef(null);
    const divRef = useRef(null);
    const handleScroll = () => {
        const div = divRef.current;
        if (div) {
            const isAtBottom = div.scrollTop + div.clientHeight >= div.scrollHeight;
            if (isAtBottom) {
                const newLimit = limitRange + 1;
                setLimitRange(newLimit);
            }
        }
    };
    const hideOnClickOutside = (e) => {
        if (refSelect.current && !refSelect.current.contains(e.target)) {
            setOpen(false);
        }
    };
    const dateFilteredData = (item) => {
        setLimitRange(0);
        setRange([item.selection]);
        getSecurityTransactionDetails(branchCode, limitRange, range, rangeValue);
    };

    const rangeValueOptions = [
        {label: "10", value: 10},
        {label: "25", value: 25},
        {label: "50", value: 50},
        {label: "100", value: 100},
        {label: "All", value: 5},
    ];

    const newRangeValue = (e) => {
        setLimitRange(0);
        let rValue = e.target.value;
        if (rValue != 5) {
            setRangeValue(rValue);
        } else {
            setRangeValue(5);
        }
    };

    const options = {
        onSizePerPageChange: (sizePerPage, page) => {
            setPageSize(sizePerPage);
        },
        onPageChange: (page, sizePerPage) => {
            setPageNumber(page);
        },
    };
    const getSecurityTransactionDetails = async (branchId, limitRange, range, rangeValue) => {
        try {
            const startDate = format(range[0].startDate, "yyyy-MM-dd");
            const endDate = format(range[0].endDate, "yyyy-MM-dd");
            // console.log(branchId);
            // console.log(startDate);
            // console.log(endDate);
            // console.log(limitRange);

            const data = await axios.get("getSecurityTransactionDetailsByBranchIdBetweenDates/" +
                branchId +
                "/" +
                startDate +
                "/" +
                endDate +
                "/" +
                limitRange +
                "/" +
                rangeValue
            );
            if (limitRange == 0 || rangeValue == 5) {
                setTableData(data.data);
            } else {
                setTableData([...tableData, ...data.data]);
            }
            // setTableData(data.data);

            setLoading(true);
        } catch (e) {
        }
    };

    useEffect(() => {
        AOS.init();
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let date = new Date();

        const format = months[date.getMonth()] + date.getDate() + ',' + date.getFullYear();
        setFormatDate(format);
    }, [])

    useEffect(() => {
        // const branchId = localStorage.getItem("branchId");
        getSecurityTransactionDetails(branchCode, limitRange, range, rangeValue);
        // document.addEventListener("click", hideOnClickOutside, true);
    }, [limitRange, range, rangeValue]);

    const {ExportCSVButton} = CSVExport;

    const MyExportCSV = (props) => {
        const handleClick = () => {
            props.onExport();
        };
        return (
            <div className="exportButton">
                <button className="btn btn-success" onClick={handleClick}>
                    Export to CSV !!
                </button>
            </div>
        );
    };

    const columns = [
        {
            dataField: "sec_id",
            text: "S No.",
            formatter: (cell, row, rowIndex) => {
                return (pageNumber - 1) * pageSize + (rowIndex + 1);
            },
            headerStyle: (colum, colIndex) => {
                return {width: "60px", textAlign: "center"};
            },
        },
        {
            dataField: "transactionDate",
            text: "Date",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "vendorName",
            text: "Vendor Name",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "labourName",
            text: "Labour Name",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "entryType",
            text: "Entry Type",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "shiftName",
            text: "Shift Name",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "createdDate",
            text: "Created Date",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "createdBy",
            text: "Created By",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
    ];

    return (
        <Card className="cardStyl">
            <Container fluid className="px-0">
                <div className={"mt-2"}>
                    {/*<h2>Laborer Master</h2>*/}
                    <h5 className={"priColor"}>Security Attendance List</h5>
                </div>
                <div>
                    <div className={"row"}>
                        <div style={{marginBottom: "10px"}}>
                            {/*<button className={"btn btn-primary"} variant="primary"*/}
                            {/*        style={{ float: "left" }}*/}
                            {/*        >*/}
                            {/*    Filter*/}
                            {/*</button>*/}
                            {/* <button className={"btn btn-primary"} variant="primary"
                                style={{ float: "right" }}
                                onClick={(e)=> HandleEvent(7.1)}>
                            Add New
                        </button> */}
                        </div>
                    </div>
                    <div></div>
                    <div className="subDiv">
                        <div className={"inputImage"}>
                            <input
                                value={`${format(range[0].startDate, "dd/MM/yyyy")} - ${format(
                                    range[0].endDate,
                                    "dd/MM/yyyy"
                                )}`}
                                className="inputElement"
                                readOnly
                                onClick={() => setOpen((open) => !open)}
                            />
                            <FontAwesomeIcon
                                icon={faCalendarDays}
                                className="Calendericon"
                                onClick={() => setOpen((open) => !open)}
                            />
                        </div>
                        <div>
                            <Form.Select className="selectSize" value={rangeValue} onChange={newRangeValue}>
                                {rangeValueOptions.map((rangeValueOption) => (
                                    <option value={rangeValueOption.value}>{rangeValueOption.label}</option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                    <div ref={refSelect}>
                        {open && (
                            <div className={"daterangepickerdiv"}>
                                <DateRangePicker
                                    onChange={(item) => dateFilteredData(item)}
                                    editableDateInputs={true}
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={range}
                                    direction="horizontal"
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <ToolkitProvider
                            keyField="sec_id"
                            data={tableData}
                            columns={columns}
                            exportCSV={{
                                fileName: "SecurityAttendance" + '  ' + formatDate + ".csv",
                                onlyExportFiltered: true, exportAll: false
                            }}
                        >
                            {(props) => (
                                <React.Fragment>
                                    {loading ? <MyExportCSV {...props.csvProps} /> : ""}
                                    <div data-aos="zoom-in-right" data-aos-duration="550"
                                         ref={divRef}
                                         style={{
                                             height: "380px",
                                             overflow: "auto",
                                         }}
                                         onScroll={handleScroll}
                                    >
                                        <BootstrapTable
                                            bootstrap4
                                            // keyField="sec_id"
                                            // data={tableData}
                                            // columns={columns}
                                            wrapperClasses="table-responsive"
                                            // pagination={paginationFactory(options)}
                                            filter={filterFactory()}
                                            {...props.baseProps}
                                        />
                                    </div>

                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    </div>
                </div>
            </Container>
        </Card>
    );
}

export default SecurityReportPage;
